import hupassApi, { type SortOption } from 'app/hupassApi';
import { atom } from 'recoil';

export const sortOptionsState = atom<SortOption[]>({
  key: 'sortOptions',
  default: hupassApi.GetSortOptions().then((res) => res.data),
});
